import {
    CheckOutlined,
    CloseOutlined,
} from '@ant-design/icons';
import { Switch, message, Tooltip } from 'antd';
import { createStyles } from 'antd-style';
import React, { useState, useEffect } from 'react';
import { getTakingOrderStatus, updateTakingOrderStatus } from '@/services/ant-design-pro/taking-order';

const useStyles = createStyles(({ token }) => {
    return {
        takingOrderContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '0 16px',
            height: '48px',
            borderRadius: token.borderRadius,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                borderColor: 'rgba(255, 255, 255, 0.3)',
            },
        },
        statusText: {
            // color: '#fff',
            fontSize: '14px',
            fontWeight: 500,
            userSelect: 'none',
        },
        statusIcon: {
            fontSize: '16px',
        },
    };
});

export const TakingOrderSwitch: React.FC = () => {
    const [takingOrderStatus, setTakingOrderStatus] = useState<boolean>(false);
    const [statusLoading, setStatusLoading] = useState<boolean>(false);
    const { styles } = useStyles();

    // 获取接单状态
    const fetchTakingOrderStatus = async () => {
        try {
            const response = await getTakingOrderStatus();
            if (response.code === 0 && response.data) {
                setTakingOrderStatus(response.data.is_taking_order);
            }
        } catch (error) {
            console.error('获取接单状态失败:', error);
        }
    };

    // 更新接单状态
    const handleTakingOrderChange = async (checked: boolean) => {
        setStatusLoading(true);
        try {
            const response = await updateTakingOrderStatus({ is_taking_order: checked });
            if (response.code === 0) {
                setTakingOrderStatus(checked);
                message.success(checked ? '已开启接单' : '已暂停接单');
            } else {
                message.error(response.msg || '状态更新失败');
            }
        } catch (error) {
            message.error('状态更新失败');
        } finally {
            setStatusLoading(false);
        }
    };

    useEffect(() => {
        fetchTakingOrderStatus();
    }, []);

    return (
        <Tooltip
            title={takingOrderStatus ? '点击暂停接单' : '点击开启接单'}
            placement="bottom"
        >
            <div className={styles.takingOrderContainer}>
                <span className={styles.statusText}>
                    {takingOrderStatus ? '接单中' : '已暂停'}
                </span>
                <Switch
                    checked={takingOrderStatus}
                    onChange={handleTakingOrderChange}
                    loading={statusLoading}
                    size="small"
                    checkedChildren="开"
                    unCheckedChildren="关"
                />
            </div>
        </Tooltip>
    );
}; 